import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-habilitar',
  templateUrl: './habilitar.component.html',
  styleUrls: ['./habilitar.component.scss']
})
export class HabilitarComponent implements OnInit {

  public email;
  public comprobante;

  constructor() { }

  ngOnInit(): void {
  }

  resolved(captchaRespons) {
    let boton = document.getElementById("enviar") as HTMLInputElement;
    boton.disabled = false;
  }

  enviar(url)
  {
    window.open(url); 
  }
}
